//==============================================
// Block: Home Hero
//==============================================

var initBlockHeroHome = function( $block ) {

    let blockInit = gsap.timeline(),

    blockImageOverlay = $block.find('.block-image-overlay'),
    blockContent = $block.find('.block-content, .block-util'),
    blockImageBar = $block.find('.block-image-bar');

    
    blockInit.to(blockImageOverlay, {duration: 1.5, ease: "power1.out", delay: 0.5, width: 0, marginRight: '100%'})
        .to(blockContent, {duration: 0.8, ease: "power1.out", stagger: 0.3, opacity: 1})
        .to(blockImageBar, {duration: 1, ease: "power1.out", width: '50%', marginLeft: 0});


};


// Initialize each block on page load (front end).
$(document).ready(function(){
    $('.block-home-hero').each(function(){
        initBlockHeroHome( $(this) );
    });
});

if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=block-hero-home', initBlockHeroHome );
}